import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Country } from '../models/country';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  http = inject(HttpClient);
  translocoService = inject(TranslocoService);

  getCountryList(): Observable<Country[]> {
    return this.http.get<Country[]>(`${environment.apiUrl}/countries`);
  }

  getCountry(code: string): Observable<Country> {
    return this.http.get<Country>(`${environment.apiUrl}/countries/${code}`);
  }

  async getCountryName(code: string): Promise<string> {
    const country = await firstValueFrom(this.getCountry(code));
    return this.getCountryLabelByLang(country);
  }

  getCountryLabelByLang(country: Country): string {
    switch (this.translocoService.getActiveLang()) {
      case 'fr':
        return country.FR;
      case 'en':
        return country.EN;
      case 'nl':
        return country.NL;
      default:
        return country.EN; // Langue par défaut
    }
  }
}
